<template>
  <div class="detai-container main-w">
    <!-- 面包屑 -->
    <Crumbs>
      <template v-slot:current> 关于证书 </template>
    </Crumbs>
    <!-- 详细页内容 -->
    <div ref="detail" style="font-size: 16px;" class="detail-content" v-html="certAbout.content"></div>
  </div>
</template>

<script>
import Crumbs from '@/components/Crumbs'
export default {
  components: {
    Crumbs
  },
  data() {
    return {
      certAbout: {}
    }
  },
  methods: {
    async getAbout() {
      const {data} = await this.service1('About/aboutShow', 'post')
      this.certAbout = data
    }
  },
  created() {
    this.getAbout()
  }
}
</script>
<style lang="less" scoped>
.detail-container {
  box-sizing: border-box;
  background-color: #fff;
  padding: 10px 23px;
}
</style>